import React from 'react';
import {get as _get} from 'lodash';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {Segment} from 'semantic-ui-react';

import {graphql} from 'react-apollo';
import HeaderRenderer from '@appComponents/HeaderRenderer';
import {FilterQueryWrapper, FilterUrlParamsWrapper} from '@appComponents/HOCFiltersQueryWrapper';
import {getSearchFilters} from '@utils/filters';
import {convertToInt} from '@utils/helpers';
import mapModulesToProps from '@utils/mapModulesToProps';
import navigation from '@constants/navigation';
import {ArgosJobLiveControl as ArgosJobLiveControlQuery} from '@graphql/argosJobLiveControl/query';

import ArgosJobLiveControlTable from '../components/ArgosJobLiveControlTable/ArgosJobLiveControlTable';
import ArgosJobLiveControlFilters from '../components/ArgosJobLiveControlFilters';
import ArgosJobLiveControlModalRouting from '../components/ArgosJobLiveControlModalRouting';
import ArgosJobLiveControlLegend from './ArgosJobLiveControlLegend';

export class ArgosJobLiveControlIndex extends React.Component {
    static propTypes = {
        ArgosJobLiveControl: PropTypes.object,
        Menu: PropTypes.object,
        filters: PropTypes.object,
        loadingRefetch: PropTypes.bool.isRequired,
    };

    static defaultProps = {
        filters: {
            preBuffer: 2,
            postBuffer: 2,
        },
    };

    state = {
        argosJobLiveControlList: [],
    };

    componentDidMount() {
        this.props.Menu.storeMenu(navigation.tools.key);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const list = nextProps.ArgosJobLiveControl?.argosJobLiveControlList;

        if (list && prevState.argosJobLiveControlList !== list) {
            return {argosJobLiveControlList: list};
        }

        return null;
    }

    render() {
        const loading = this.props.ArgosJobLiveControl?.loading || this.props.loadingRefetch;

        return (
            <div>
                <ArgosJobLiveControlModalRouting/>
                <HeaderRenderer
                    pageTitle='Argos job Live Control'
                    messagesBoxNames={['argosJobLiveControl', 'argosJobMessage', 'argosJobMessageError']}
                    buttons={ArgosJobLiveControlLegend}
                    filters={ArgosJobLiveControlFilters}
                    filtersProps={{
                        loading,
                    }}
                />
                <Segment basic className='--table'>
                    <ArgosJobLiveControlTable
                        argosJobLiveControlList={this.state.argosJobLiveControlList}
                        loading={loading}
                        refetch={this.props.ArgosJobLiveControl?.refetch}
                    />
                </Segment>
            </div>
        );
    }
}

const mapDispatchToProps = mapModulesToProps(['Menu']);

const mapStateToProps = (state) => ({
    filters: getSearchFilters(state, 'ArgosJobLiveControl'),
});

const ArgosJobLiveControlWithQuery = compose(
    graphql(ArgosJobLiveControlQuery, {
        options: (props) => ({
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'network-only',
            variables: {
                preBuffer: convertToInt(_get(props.filters, 'preBuffer', 2)),
                postBuffer: convertToInt(_get(props.filters, 'postBuffer', 2)),
            },
        }),
        name: 'ArgosJobLiveControl',
    })
)(FilterQueryWrapper(ArgosJobLiveControlIndex, {
    queryForRefresh: 'ArgosJobLiveControl',
    filterUrls: ['argosJobLiveControl.index'],
}));

export default connect(mapStateToProps, mapDispatchToProps)(
    FilterUrlParamsWrapper(
        ArgosJobLiveControlWithQuery,
        ArgosJobLiveControlIndex.defaultProps.filters,
        'argosJobLiveControl.index'
    ));
